import { persistCombineReducers } from "redux-persist";
import storage from "redux-persist/lib/storage";
import entities from "./entities";
import app from "./app";
import me from "./me";
import pages from "./pages";
import options from "./options";
import faq from "./faq";
import artists from "./artists";
import spaces from "./spaces";
import newsletter from "./newsletter";
import team from "./team";
import blog from "./blog";
import search from "./search";
import openCalls from "./openCalls";
import events from "./events";
import lessons from "./lessons";
import tickers from "./tickers";
import spaceReservations from "./spaceReservations";

const persistConfig = {
    key: "root",
    storage,
    whitelist: ["app"],
    debug: process.env.NODE_ENV === "development",
};

export default persistCombineReducers(persistConfig, {
    entities,
    app,
    me,
    pages,
    options,
    faq,
    artists,
    spaces,
    newsletter,
    team,
    blog,
    search,
    openCalls,
    events,
    lessons,
    tickers,
    spaceReservations,
});
